export const formatDateForInput = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getThisMonthDates = () => {
  const today = new Date();
  const from = new Date(today.getFullYear(), today.getMonth(), 1);
  const to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  return {
    from: formatDateForInput(from),
    to: formatDateForInput(to),
  };
};

export const buildDateRangeParams = (dateFrom, dateTo) => {
  const params = new URLSearchParams();
  if (dateFrom) params.append("date_from", new Date(dateFrom).toISOString());
  if (dateTo) {
    const toDateTime = new Date(dateTo);
    toDateTime.setHours(23, 59, 59, 999);
    params.append("date_to", toDateTime.toISOString());
  }
  return params;
};
